import React from 'react';

const Contact: React.FC = () => {

  return (
    <div className="contact-container">
      <div className="contact-grid">
        {/* Sol: Metin ve Bilgiler */}
        <div className="contact-left">
          <h1>Nasıl Yardımcı Olabiliriz?</h1>
          <div style={{ marginBottom: '2rem' }}>
            <p>Size özel kostüm önerilerimiz var…</p>
            <p>Hangi etkinlik için kostüm arıyorsunuz?</p>
            <p>Beden, renk, tema konusunda tavsiyelere ihtiyacınız mı var?</p>
            <p>Kostüm Akademi ekibi olarak, size en uygun seçimi yapmanızda yardımcı olmak için buradayız!</p>
          </div>
          <div style={{ marginBottom: '1.5rem' }}>
            <div className="contact-info-row"><span>📞 0(501) 568 50 55</span></div>
            <div className="contact-info-row"><span>✉️</span>kostumakademi@gmail.com</div>
          </div>
        </div>
        {/* Sağ: WhatsApp İletişim */}
        <div className="contact-form-box">
          <h2>WhatsApp ile İletişime Geçin</h2>
          <div style={{ 
            padding: '2rem', 
            backgroundColor: '#f8fafc', 
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
            textAlign: 'center'
          }}>
            <div style={{ 
              fontSize: '1.1rem', 
              color: '#374151', 
              marginBottom: '1.5rem',
              lineHeight: '1.6'
            }}>
              Kostüm kiralama ve satın alma konularında sorularınız için WhatsApp üzerinden bizimle iletişime geçebilirsiniz.
            </div>
            <button
              onClick={() => {
                window.open('https://wa.me/905015685055?text=Merhaba, kostüm kiralama konusunda bilgi almak istiyorum.', '_blank');
              }}
              style={{
                width: '100%',
                padding: '1rem 2rem',
                backgroundColor: '#668A69',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1.1rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease',
                fontFamily: '"Inter", "Segoe UI", -apple-system, sans-serif',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}
              onMouseOver={(e) => (e.target as HTMLButtonElement).style.backgroundColor = '#567a5a'}
              onMouseOut={(e) => (e.target as HTMLButtonElement).style.backgroundColor = '#668A69'}
            >
              💬 WhatsApp ile İletişime Geç
            </button>
            <div style={{ 
              fontSize: '0.9rem', 
              color: '#6b7280', 
              marginTop: '1rem',
              fontStyle: 'italic'
            }}>
              Hızlı yanıt için WhatsApp tercih edilir
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 